/**
 * GraphQL Query: GetTestData
 * Get test data (The Answer to Life, the Universe, and Everything)
 */
export const GET_TEST_DATA = `
  query GetTestData {
    testData {
      id
      answer
      question
      description
      testColumn
      createdAt
      updatedAt
    }
  }
`;
//# sourceMappingURL=getTestData.js.map